// Franja arriba de las tabs en /admin/productos/:sku
// Lee vw_productos_analisis_multicanal y muestra semáforo por canal + detalle expandible.
// Datos: costo + precio + peso + config MELI/MP. Calculado en SQL (0 lógica cliente).

import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'

export default function AnalisisMulticanalHeader({ productoId }) {
  const [a, setA] = useState(null)
  const [loading, setLoading] = useState(true)
  const [expandido, setExpandido] = useState(false)
  const [mlComPct, setMlComPct] = useState(13.5)

  useEffect(() => {
    if (!productoId) return
    setLoading(true)
    supabase
      .from('vw_productos_analisis_multicanal')
      .select('*')
      .eq('id', productoId)
      .maybeSingle()
      .then(({ data, error }) => {
        if (error) console.error('[AnalisisMulticanal]', error)
        setA(data)
        setLoading(false)
      })
  }, [productoId])

  useEffect(() => {
    supabase.from('app_config').select('value').eq('key', 'ml_comision_pct').maybeSingle()
      .then(({ data }) => { const v = Number(data?.value); if (v > 0) setMlComPct(v) })
  }, [])

  if (loading || !a) return null

  const chipCanal =
    a.canal_recomendado === 'ambos' ? { txt: 'Publicar en ambos', bg: '#D1FAE5', fg: '#065F46' } :
    a.canal_recomendado === 'ml_solo' ? { txt: 'ML solo · alta renta', bg: '#FEF3C7', fg: '#78350F' } :
    a.canal_recomendado === 'kit_ml' ? { txt: 'ML solo en kit', bg: '#DBEAFE', fg: '#1E3A8A' } :
    a.canal_recomendado === 'tienda' ? { txt: 'Solo tienda', bg: '#E0F2FE', fg: '#075985' } :
    { txt: 'No conviene', bg: '#FEE2E2', fg: '#991B1B' }

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(26,52,97,0.04), rgba(0,168,181,0.06))',
      border: '1px solid rgba(26,52,97,0.12)',
      borderRadius: 12,
      padding: '14px 18px',
      marginTop: 24,
      marginBottom: 4,
    }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 14, fontWeight: 800, color: 'var(--navy-ink)' }}>
            📊 Análisis rentabilidad multicanal
          </span>
          <span style={{
            fontSize: 11, fontWeight: 700, background: chipCanal.bg, color: chipCanal.fg,
            padding: '3px 10px', borderRadius: 999
          }}>
            🎯 {chipCanal.txt}
          </span>
        </div>
        <button
          onClick={() => setExpandido(v => !v)}
          style={{
            background: 'none', border: '1px solid #E5E7EB', color: '#374151',
            padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600
          }}
        >
          {expandido ? '▲ Ocultar detalle' : '▼ Ver fórmula'}
        </button>
      </div>

      {/* Semáforo por canal */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10 }}>
        <CanalCard icon="🛒" label="Tienda B2C" precio={fmt(a.precio_web)} pct={a.renta_tienda_pct} sem={a.sem_tienda} />
        <CanalCard icon="📅" label="Suscripción" precio={fmt(a.precio_web)} pct={a.renta_susc_pct} sem={a.sem_tienda} />
        <CanalCard icon="🟡" label="ML solo" precio={fmt(a.precio_ml_opt)} pct={a.renta_ml_solo_pct} sem={a.sem_ml_solo} nota={fijoNota(a.fijo_ml)} />
        <CanalCard icon="🎁" label="ML en kit" precio="≥$1.001" pct={a.renta_ml_kit_pct} sem={a.sem_ml_kit} nota="sin fijo" />
      </div>

      {/* Recomendación */}
      <div style={{ marginTop: 12, fontSize: 12.5, color: '#1F2937', lineHeight: 1.4 }}>
        💡 <strong>{a.motivo_recomendacion}</strong>
      </div>

      {/* Detalle expandido */}
      {expandido && (
        <div style={{
          marginTop: 14, padding: 14, background: 'white', borderRadius: 8,
          border: '1px solid #E5E7EB', fontSize: 12.5
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#6B7280', borderBottom: '1px solid #E5E7EB' }}>
                <th style={{ padding: '6px 8px', fontWeight: 600 }}>Concepto</th>
                <th style={{ padding: '6px 8px', textAlign: 'right', fontWeight: 600 }}>Tienda B2C</th>
                <th style={{ padding: '6px 8px', textAlign: 'right', fontWeight: 600 }}>ML solo</th>
                <th style={{ padding: '6px 8px', textAlign: 'right', fontWeight: 600 }}>ML en kit</th>
              </tr>
            </thead>
            <tbody>
              <Row label="Precio venta" cols={[a.precio_web, a.precio_ml_opt, a.precio_ml_opt]} bold />
              <Row label="Costo unitario" cols={[-a.costo, -a.costo, -a.costo]} neg />
              <Row label="Costo fijo MELI" cols={[0, -a.fijo_ml, 0]} neg />
              <Row label="Comisión procesador" cols={[-a.precio_web * 0.05, -a.precio_ml_opt * (mlComPct / 100), -a.precio_ml_opt * (mlComPct / 100)]} neg />
              <Row label={a.ml_absorbe_envio ? 'Envío (vos absorbés)' : 'Envío (comprador paga)'}
                   cols={[0,
                          a.ml_absorbe_envio ? -a.envio_ml : 0,
                          a.ml_absorbe_envio ? -a.envio_ml / 2 : 0]}
                   neg />
              <tr style={{ borderTop: '2px solid var(--navy-ink)', fontWeight: 800 }}>
                <td style={{ padding: '9px 8px', color: 'var(--navy-ink)' }}>NETO</td>
                <td style={{ padding: '9px 8px', textAlign: 'right', color: colorSem(a.sem_tienda) }}>
                  {fmt(a.neto_tienda)} <span style={{ opacity: 0.7 }}>({a.renta_tienda_pct}%)</span>
                </td>
                <td style={{ padding: '9px 8px', textAlign: 'right', color: colorSem(a.sem_ml_solo) }}>
                  {fmt(a.neto_ml_solo)} <span style={{ opacity: 0.7 }}>({a.renta_ml_solo_pct}%)</span>
                </td>
                <td style={{ padding: '9px 8px', textAlign: 'right', color: colorSem(a.sem_ml_kit) }}>
                  {fmt(a.neto_ml_kit)} <span style={{ opacity: 0.7 }}>({a.renta_ml_kit_pct}%)</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginTop: 10, fontSize: 11, color: '#6B7280', lineHeight: 1.5 }}>
            📦 Peso <strong>{a.peso_g}g</strong> → tarifa envío {fmt(a.envio_ml)}.
            {' '}<strong>{a.ml_absorbe_envio ? '⚠️ Vos absorbés el envío' : '✓ Comprador paga el envío'}</strong>
            {' '}(Free listing + dropoff · MELI obliga envío gratis solo arriba de $1.500 Gold Premium).
            {' '}Precio ML óptimo <strong>{fmt(a.precio_ml_opt)}</strong> salta franjas penalizadas
            del costo fijo MELI ($15 hasta $500, $25 hasta $750, $40 hasta $1.000, $0 arriba).
            {' '}Anclaje ML: web × 1,20 → luego optimizado.
          </div>
        </div>
      )}
    </div>
  )
}

function CanalCard({ icon, label, precio, pct, sem, nota }) {
  const col = colorSem(sem)
  return (
    <div style={{
      background: 'white', borderRadius: 8, padding: '9px 12px',
      border: `1px solid ${col}22`, borderLeftWidth: 3, borderLeftColor: col
    }}>
      <div style={{ fontSize: 11, color: '#6B7280', fontWeight: 600 }}>{icon} {label}</div>
      <div style={{ fontSize: 15, fontWeight: 800, color: 'var(--navy-ink)', marginTop: 2 }}>
        {precio}
      </div>
      <div style={{ fontSize: 12, color: col, fontWeight: 700, marginTop: 1 }}>
        {sem} {pct != null ? `${pct}%` : '—'}
      </div>
      {nota && <div style={{ fontSize: 10, color: '#9CA3AF', marginTop: 1 }}>{nota}</div>}
    </div>
  )
}

function Row({ label, cols, bold, neg }) {
  return (
    <tr style={{ borderBottom: '1px solid #F3F4F6' }}>
      <td style={{ padding: '6px 8px', color: bold ? 'var(--navy-ink)' : '#374151', fontWeight: bold ? 700 : 400 }}>
        {label}
      </td>
      {cols.map((c, i) => (
        <td key={i} style={{
          padding: '6px 8px', textAlign: 'right',
          color: neg && c < 0 ? '#DC2626' : '#111827',
          fontWeight: bold ? 700 : 400,
          fontVariantNumeric: 'tabular-nums'
        }}>
          {fmt(c)}
        </td>
      ))}
    </tr>
  )
}

function fmt(n) {
  if (n == null || isNaN(n)) return '—'
  const num = Number(n)
  const sign = num < 0 ? '−' : ''
  return sign + '$' + Math.abs(num).toLocaleString('es-UY', { maximumFractionDigits: 0 })
}

function colorSem(sem) {
  return sem === '🟢' ? '#059669' : sem === '🟡' ? '#D97706' : '#DC2626'
}

function fijoNota(fijo) {
  const f = Number(fijo || 0)
  if (f === 0) return 'sin fijo'
  return `fijo $${f}`
}
